import { z } from 'zod';
import { DestinoExport } from './enums.js';
// §11.5 spec técnica: formato canónico de lote de export a nómina.
export const DetalleDiario = z.object({
    fecha: z.string().date(),
    cantidad: z.number().nullable(),
    horas: z.number().nullable(),
    importe: z.number().int(),
    labor: z.string().optional(),
    cuartel: z.string().nullable().optional(),
});
export const LineaExport = z.object({
    movimiento_id: z.string().uuid(),
    id_en_nomina: z.string(),
    rut: z.string(),
    sociedad: z.string(),
    concepto: z.string(),
    clase_salario: z.string().nullable(),
    fecha_inicio: z.string().date(),
    fecha_fin: z.string().date(),
    cantidad: z.number().nullable(),
    unidad: z.string().nullable(),
    importe: z.number().int(),
    moneda: z.literal('CLP'),
    objeto_costo: z.string().nullable(),
    movimiento_corrige_id: z.string().uuid().nullable().optional(),
    detalle_diario: z.array(DetalleDiario),
});
export const LoteExportCanonico = z.object({
    lote_id: z.string().uuid(),
    destino: DestinoExport,
    formato_version: z.literal('1.0'),
    periodo_imputacion: z.string().regex(/^\d{4}-\d{2}$/),
    lineas: z.array(LineaExport),
});
export const AcuseLinea = z.object({
    movimiento_id: z.string().uuid(),
    resultado: z.enum(['aceptado', 'rechazado']),
    mensaje: z.string().optional(),
    referencia_nomina: z.string().optional(),
    periodo_nomina: z.string().regex(/^\d{4}-\d{2}$/).optional(),
    monto_bruto_pagado: z.number().int().optional(),
});
export const AcusesLote = z.object({ acuses: z.array(AcuseLinea).min(1) });
//# sourceMappingURL=nomina.js.map